var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    "data-inject-url": "https://edublink.html.devsblink.com/assets/images/animated-svg-icons/off-campus-programs.svg",
    className: "svgInject",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.095 39.0474H1.90453C1.38072 39.0474 0.952148 38.6188 0.952148 38.095V1.90453C0.952148 1.38072 1.38072 0.952148 1.90453 0.952148H38.095C38.6188 0.952148 39.0474 1.38072 39.0474 1.90453V38.095C39.0474 38.6188 38.6188 39.0474 38.095 39.0474Z",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "151, 153",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.952148 9.75195H39.0474",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    style: {
      strokeDasharray: "39, 41",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3997 18.2383L9.35205 24.0859L13.9997 29.924",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "16, 18",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0664 18.2383L29.1045 24.0859L24.4664 29.924",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "16, 18",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4379 18.2383L16.9141 29.924",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "13, 15",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78086 6.00899C6.0123 6.00899 6.19991 5.82138 6.19991 5.58995C6.19991 5.35851 6.0123 5.1709 5.78086 5.1709C5.54943 5.1709 5.36182 5.35851 5.36182 5.58995C5.36182 5.82138 5.54943 6.00899 5.78086 6.00899Z",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42832 6.00899C9.65976 6.00899 9.84737 5.82138 9.84737 5.58995C9.84737 5.35851 9.65976 5.1709 9.42832 5.1709C9.19689 5.1709 9.00928 5.35851 9.00928 5.58995C9.00928 5.82138 9.19689 6.00899 9.42832 6.00899Z",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0665 6.00899C13.2979 6.00899 13.4856 5.82138 13.4856 5.58995C13.4856 5.35851 13.2979 5.1709 13.0665 5.1709C12.8351 5.1709 12.6475 5.35851 12.6475 5.58995C12.6475 5.82138 12.8351 6.00899 13.0665 6.00899Z",
    stroke: "#4664e4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      strokeDasharray: "3, 5",
      strokeDashoffset: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory3);
export default __webpack_public_path__ + "static/media/category-3.5a4007296dbd037020cb221712dd4f21.svg";
export { ForwardRef as ReactComponent };